export default __webpack_public_path__ + "680d129c241b9c14c329a9aaf38da308.png";